import ReactJS, { useRef, useEffect, useState, useMemo } from "react";
import Toolbar from "../../components/Toolbar";
import AxiosAPI from "../../scripts/AxiosAPI";
import { Badge, Flex, Modal, notification, Popconfirm, Tabs } from "antd";

import { SearchOutlined } from "@ant-design/icons";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import DeleteButtonGroup from "../../components/DeleteButtonGroup";
import ExportCSVButton from "../../components/ExportCSVButton";

interface DataType {
  key: string;
  name: string;
  points: any;
  action: any;
}

type DataIndex = keyof DataType;

function RewardsGroupsComponent() {
  const [itemLabel, setItemLabel] = useState("");

  const [selectedItem, setSelectedItem] = useState({
    id: 0,
    name: "",
    points: 0,
  });

  const [items, setItems] = useState([]);

  const [modalOpenCreate, setModalOpenCreate] = useState(false);

  const [modalOpenEdit, setModalOpenEdit] = useState(false);

  const [modalOpenAddTenantToGroup, setModalOpenAddTenantToGroup] = useState(false);

  const [id, setId] = useState(0);

  const [name, setName] = useState("");

  const [group, setGroup] = useState(0);

  const [tenant, setTenant] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  const addItem: any = () => {
    setModalOpenCreate(false);

    console.log("addItem", { id: 0, name });

    AxiosAPI.setRewardsTenantGroups(name, 0)
      .then((res: any) => {
        console.log(res.data);

        api.info({
          message: `Completed`,
          description: `${name} has been added successfully!`,
          placement: `topRight`,
        });

        refreshListView();
      })
      .catch(() => {});
  };

  const addTenant: any = () => {
    setModalOpenCreate(false);

    console.log("addItem", { id: 0, name });

    AxiosAPI.addRewardsGroupTenant(group, tenant)
      .then((res: any) => {
        console.log(res.data);

        api.info({
          message: `Completed`,
          description: `Tenant added successfully!`,
          placement: `topRight`,
        });

        refreshListView();
      })
      .catch(() => {});
  };

  const openNewItemModal: any = () => {
    
    setId(0);

    setName("");

    setTenant(0);

    setGroup(0);

    setModalOpenCreate(true);
  };

  const editItem: any = () => {

    setModalOpenEdit(false);

    setModalOpenCreate(false);

    console.log("addItem", { id, name });

    AxiosAPI.setRewardsTenantGroups(name, id)
      .then((res: any) => {
        console.log(res.data);

        api.info({
          message: `Completed`,
          description: `${name} has been updated successfully!`,
          placement: `topRight`,
        });

        refreshListView();
      })
      .catch(() => {});
  };

  const editThisItem: any = (item: any) => {

    setTenant(0);

    setGroup(0);

    setModalOpenEdit(true);

    setModalOpenCreate(false);

    setSelectedItem(item);

    console.log("editThisItem::", item);

    console.log("addItem", { id, name });

    setId(item.id);

    setName(item.name);
    
  };

  const addTenantToGroup: any = (item: any) => {

    setModalOpenEdit(false);

    setModalOpenCreate(false);

    setModalOpenAddTenantToGroup(true);

    setSelectedItem(item);

    setTenant(0);

    setGroup(0);

  };

  useEffect(() => {
    setItemLabel("Reward Groups");

    AxiosAPI.setRewardsTenantGroups(name, id)
      .then((res: any) => {
        const _data = res.data;

        setItems(_data);
      })
      .catch((error: any) => {});
  }, []);

  useEffect(() => {
    setModalOpenCreate(false);
  }, [selectedItem]);

  const [groupsData, setGroupsData] = useState([]);

  const [exportData, setExportData] = useState([]);

  const [tenants, setTenants] = useState([]);

  const refreshListView: any = () => {

    AxiosAPI.getTenantList()
      .then((res: any) => {
        let _tenants: any = res.data.filter((value: any) => value.name !== "");
        console.log("TENANTS::", _tenants);
        setTenants(_tenants);
    })
    .catch((error: any) => {
      // Handle error
    });

    AxiosAPI.getRewardsTenantGroups()
      .then((res: any) => {
        let _groups: any = res.data.filter((value: any) => value.name !== "");
        setExportData(_groups);
        const activeItems: any = _groups.map((item: any, itemIndex: number) => {
          return {
            key: itemIndex,
            name: item.name,
            action: (
              <Flex gap={20}>
                <Button
                  type="primary"
                  size="large"
                  onClick={() => editThisItem(item)}
                  className="m-r-5"
                >
                  Edit Group
                </Button>
                <Button
                  type="default"
                  size="large"
                  onClick={() => addTenantToGroup(item)}
                  className="m-r-5"
                >
                  Add Tenant
                </Button>
              </Flex>
            ),
          };
        });
        setGroupsData(activeItems);
        console.log("updatedLevesupdatedLeves");
      })
      .catch((error: any) => {
        // Handle error
      });
  };

  useMemo(() => {
    refreshListView();
  }, []);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "20%",
    },
  ];

  const operations = <Button onClick={refreshListView}>Refresh Data</Button>;

  const [tabItems, setTabItems] = useState<any>([]);

  useEffect(() => {
    setTabItems([
      {
        label: (
          <>
            Reward Groups{" "}
            <Badge count={groupsData.length} showZero color="#1c84ff" />
          </>
        ),
        key: 1,
        children: <Table columns={columns} dataSource={groupsData} />,
      },
    ]);
  }, [groupsData]);

  return (
    <>
      {contextHolder}
      {/*begin::Toolbar*/}
      <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">
        <Toolbar title={itemLabel}>
          {/*begin::Toolbar*/}
          <div
            className="d-flex justify-content-end"
            data-kt-user-table-toolbar="base"
            data-select2-id="select2-data-131-i76u"
          >
            <Flex gap={16}>
            {/*begin::Add user*/}
            <Button
              type="primary"
              size="large"
              onClick={openNewItemModal}
            >
              Add New
            </Button>
            {/*end::Add user*/}
            {/*begin::Export*/}
            <ExportCSVButton csvData={[...exportData]} />
            {/*end::Export*/}
            </Flex>
          </div>
          {/*end::Toolbar*/}
        </Toolbar>
      </div>
      {/*end::Toolbar*/}
      {/*begin::Content*/}
      <div
        id="kt_app_content"
        className="app-content  flex-column-fluid "
        data-select2-id="select2-data-kt_app_content"
      >
        {/*begin::Content container*/}
        <div
          id="kt_app_content_container"
          className="app-container  container-xxl "
          data-select2-id="select2-data-kt_app_content_container"
        >
          {/*begin::Card*/}
          <div className="card" data-select2-id="select2-data-134-i7jk">
            {/*begin::Card body*/}
            <div className="card-body py-4">
              {/*begin::Table*/}
              <div
                id="kt_table_users_wrapper"
                className="dt-container dt-bootstrap5 dt-empty-footer pt-5"
              >
                <Tabs tabBarExtraContent={operations} items={tabItems} />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Content container*/}
      </div>
      {/*end::Content*/}

      <Modal
        title={`Add Tenant To Group`}
        centered
        open={modalOpenAddTenantToGroup}
        onOk={() => {
          addTenant();
          setModalOpenAddTenantToGroup(false);
        }}
        onCancel={() => setModalOpenAddTenantToGroup(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
        {/*begin::Input group*/}
        <div className="fv-row mb-7 fv-plugins-icon-container">
          {/*begin::Label*/}
          <label className="required fw-semibold fs-6 mb-2">Group</label>
          {/*end::Label*/}
          {/*begin::Input*/}
          <select  
              title=""
              className="form-control form-control-solid mb-3 mb-lg-0"
              value={group}
              onChange={(e) => setGroup(Number(e.target.value))}
            >
                <option>---- Select Group ---</option>

                {exportData.map((item:any, itemIndex:number)=>(
                    <option key={itemIndex} value={item.id}>{item.name}</option>
                ))}


            </select>
          {/*end::Input*/}
          <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
        </div>
        {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">Tenant</label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <select  
              title=""
              className="form-control form-control-solid mb-3 mb-lg-0"
              value={tenant}
              onChange={(e) => setTenant(Number(e.target.value))}
            >
                <option>---- Select Tenant ---</option>
                {tenants.map((item:any, itemIndex:number)=>(
                    <option key={itemIndex} value={item.id}>{item.name}</option>
                ))}

            </select>
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
        </div>
        {/*end::Scroll*/}
      </Modal>

      <Modal
        title={`Add New Group`}
        centered
        open={modalOpenCreate}
        onOk={() => {
          addItem();
          setModalOpenCreate(false);
        }}
        onCancel={() => setModalOpenCreate(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">Group</label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The group label"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
        </div>
        {/*end::Scroll*/}
      </Modal>

      <Modal
        title={`Edit ${name}`}
        centered
        open={modalOpenEdit}
        onOk={() => {
          editItem();
          setModalOpenEdit(false);
        }}
        onCancel={() => setModalOpenEdit(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">Group</label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The group label"
              value={name}
              readOnly={false}
              onChange={(e) => setName(e.target.value)}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
        </div>
        {/*end::Scroll*/}
      </Modal>
    </>
  );
}

export default RewardsGroupsComponent;
